module.exports = __webpack_public_path__ + "img/flowers3.bc0dd791.jpg";